import React from 'react';
import '../../Default.css';


function Schema() {
    return (
      <>
        <div className="page-title">
          Schemat spotkań katechetycznych RISE UP
        </div>
        <div className='boxes-contener'>
            <div className='copyright-tekst'>Przewodnik ŚDM</div>
            <div className='text-box' style={{textAlign: 'left'}}>
                <div className='text-box-header'>Rise up w dniach 2 i 3 sierpnia</div>
                <ul>
                    <li>Zawiązanie wspólnoty</li>
                    <li>Prezentacja grup i obecnych biskupów</li>
                    <li>Pieśni i modlitwy</li>
                </ul>
                <div className='text-box-subtitle'>9.30: Wprowadzenie (zespół animatorów) - 20 minut</div>
                <ul>
                    <li>Przedstawienie tematu dnia i głoszenia Ewangelii (15 minut)</li>
                    <li>Krótki czas ciszy na rozważanie Słowa Bożego (2 minuty)</li>
                    <li>Wymiana zdań na temat czytania Ewangelii, w małych grupach lub na zgromadzeniu</li>
                    <li>Dzielenie się na zgromadzeniu (15 minut)</li>
                </ul>
                <div className='text-box-subtitle'>9.50: Sesja słuchania i wymiany zdań - 50 minut</div>
                <ul>
                    <li>Słowo biskupa na temat dnia (ok. 15 minut)</li>
                    <li>Dialog między biskupem a młodzieżą na zgromadzeniu (15 minut)</li>
                    <li>Dynamika „Zbuduj dom” (5 minut)</li>
                    <li>Ostatnia piosenka</li>
                </ul>
                <div className='text-box-subtitle'>10.40: Słowo biskupa i dialog z młodzieżą – 35 minut</div>
            </div>
            <div className='text-box'>
                <div className='text-box-header'>Rise Up w dniu 4 sierpnia</div>
                <div className='text-box-subtitle'>11.15: Przerwa</div>
                <div className='text-box-subtitle'>11.30: Msza Święta (pod przewodnictwem biskupa z krótką homilią)</div>
                <div className='text-box-subtitle'>12.30: Zakończenie</div>

                <div className='text-box-subtitle'>9.30 - 11.30: Celebracja pokutna prowadzona przez zespół animacyjny.</div>
                <div className='list-header'>Zespół animacyjny zadba o:</div>
                <ul>
                    <li>Powitanie młodzieży</li>
                    <li>Ogłoszenie tematu dnia</li>
                    <li>Krótkie wprowadzenie do tematu</li>
                    <li>Naprzemiennie śpiew pieśni, czytania biblijne, cisza i skupienie, adoracja eucharystyczna</li>
                    <li>Spowiedź (obecni księża i biskupi zostaną zaproszeni do posługi)</li>
                </ul>
                <div className='text-box-subtitle'>11.30: Msza św. (przewodniczy biskup; krótka homilia)</div>
                <div className='text-box-subtitle'>12.30: Zakończenie</div>
            </div>
        </div>
      </>
    );
}

export default Schema;
